export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "first": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["First"])},
        "last": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Last"])},
        "next": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Next"])},
        "previous": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Previous"])}
      },
      "fr": {
        "first": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Début"])},
        "last": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fin"])},
        "next": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suivant"])},
        "previous": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Précédent"])}
      }
    }
  })
}
